import React from 'react'

import { Tertiary as ButtonTertiary } from '@cinch/oxd-components/button/src'
import SaveSearchModal from '@cinch/oxd-components/save-search-modal/src'

import * as styles from './save-search.module.css'

export interface Props {
  saveSearch: (name: string, filters: Cinch.FilterFormData, location: string) => {}
  isAuthenticated?: boolean
  formFilters: Cinch.FilterFormData
  location: string
  i18n: Cinch.WebAppTranslations['findVehicle']['saveSearch']
  label?: string
  untitledName?: string
}

const SaveSearch: React.FC<Props> = ({
  saveSearch,
  isAuthenticated,
  i18n,
  label,
  untitledName,
  formFilters,
  location,
}) => {
  const [isShowSaveSearch, setShowSaveSearch] = React.useState<boolean>(false)
  const showSaveSearch = () => setShowSaveSearch(true)
  const hideSaveSearch = () => setShowSaveSearch(false)

  const onSaveSearchClick = () => {
    if (isAuthenticated) {
      showSaveSearch()
    } else {
      saveSearch(untitledName || i18n.untitledName, formFilters, location)
    }
  }

  const onModalSubmit = (formValues: any) => {
    saveSearch(formValues.searchName, formFilters, location)
    hideSaveSearch()
  }

  return (
    <>
      <ButtonTertiary data-testid="save-search-button" className={styles.saveSearchButton} onClick={onSaveSearchClick}>
        {label || i18n.button}
      </ButtonTertiary>
      {isShowSaveSearch && (
        <SaveSearchModal
          data-testid="save-search-modal"
          onSubmit={onModalSubmit}
          onClose={hideSaveSearch}
          onCancel={hideSaveSearch}
        />
      )}
    </>
  )
}

export default SaveSearch
